import React from 'react';
import { User, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';

export const PersonalInfoDialog = ({
  isAuthenticated,
  profileName,
  setProfileName,
  profileEmail,
  profileCity,
  setProfileCity,
  profileCountry,
  setProfileCountry,
  savingProfile,
  saveProfile,
}) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="flex flex-col items-center gap-2 p-4 bg-slate-800/50 rounded-2xl hover:bg-slate-800 transition-colors border border-slate-700/50">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-600 flex items-center justify-center">
            <User className="h-5 w-5 text-white" />
          </div>
          <span className="text-sm text-white">Personal Info</span>
        </button>
      </DialogTrigger>
      <DialogContent 
        className="bg-slate-900 border-slate-800 max-w-md"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-600 flex items-center justify-center">
              <User className="h-4 w-4 text-white" />
            </div>
            Personal Information
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          {isAuthenticated ? (
            <>
              <div className="space-y-2">
                <Label className="text-white">Name</Label>
                <Input
                  value={profileName}
                  onChange={(e) => setProfileName(e.target.value)}
                  className="bg-slate-700 border-slate-600 text-white"
                  placeholder="Your name"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-white">Email</Label>
                <Input
                  value={profileEmail}
                  disabled
                  className="bg-slate-700/50 border-slate-600 text-slate-400"
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-2">
                  <Label className="text-white">City</Label>
                  <Input
                    value={profileCity}
                    onChange={(e) => setProfileCity(e.target.value)}
                    className="bg-slate-700 border-slate-600 text-white"
                    placeholder="Your city"
                  />
                </div>
                <div className="space-y-2">
                  <Label className="text-white">Country</Label>
                  <Input
                    value={profileCountry}
                    onChange={(e) => setProfileCountry(e.target.value)}
                    className="bg-slate-700 border-slate-600 text-white"
                    placeholder="Your country"
                  />
                </div>
              </div>
              <Button 
                onClick={saveProfile}
                disabled={savingProfile}
                className="w-full bg-blue-500 hover:bg-blue-400"
              >
                {savingProfile ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
                Save Changes
              </Button>
            </>
          ) : (
            <p className="text-slate-400 text-center py-8">Please log in to edit your profile</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PersonalInfoDialog;
